import { ExpandableTabs } from "@/components/ui/expandable-tabs";
import { FC } from "react";

interface Props {
  components: {
    key: string,
    Component: JSX.Element
  }[]
  mainComponent: JSX.Element
}

const DispatchNav: FC<Props> = ({components, mainComponent}) => {
  return <ExpandableTabs MainTab={mainComponent} tabs={components} />;
};

export default DispatchNav;
